import {useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {buildProfilePhotoCandidates} from '@utils/profilePhotoUrl';

/**
 * Muestra la foto de perfil probando varias URLs (proxy del front y host del API).
 */
const ProfilePhotoImage = ({path, preview, blobSrc, alt, className, onAllFailed}) => {
    const candidates = useMemo(() => {
        if (preview) {
            return [preview];
        }

        if (blobSrc) {
            return [blobSrc];
        }

        return buildProfilePhotoCandidates(path, {bust: true});
    }, [path, preview, blobSrc]);

    const [index, setIndex] = useState(0);

    useEffect(() => {
        setIndex(0);
    }, [path, preview, blobSrc]);

    const src = candidates[index] || null;

    if (!src) {
        return null;
    }

    return (
        <img
            className={className}
            src={src}
            alt={alt}
            onError={() => {
                if (index + 1 < candidates.length) {
                    setIndex(prev => prev + 1);
                    return;
                }

                onAllFailed?.();
            }}
        />
    );
};

ProfilePhotoImage.propTypes = {
    path: PropTypes.string,
    preview: PropTypes.string,
    blobSrc: PropTypes.string,
    alt: PropTypes.string,
    className: PropTypes.string,
    onAllFailed: PropTypes.func
};

export default ProfilePhotoImage;
